import { render, staticRenderFns } from "./History.vue?vue&type=template&id=134ee8a7&scoped=true&"
import script from "./History.vue?vue&type=script&lang=js&"
export * from "./History.vue?vue&type=script&lang=js&"
import style0 from "./History.vue?vue&type=style&index=0&id=134ee8a7&prod&scoped=true&lang=css&"
import style1 from "./History.vue?vue&type=style&index=1&id=134ee8a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134ee8a7",
  null
  
)

export default component.exports